// AI工作台基础翻译

export const workbench = {
    title: 'AI Workbench',
    subtitle: 'Professional AI-powered image generation and editing workspace',
    workbenchTitle: 'AI Image Tools Workbench',
    workbenchSubtitle: 'Explore powerful AI image processing tools to extend your creativity infinitely',
    tryNow: 'Try Now',
    moreComing: 'More Tools Coming Soon',
    moreComingDescription: 'We are continuously developing new AI image processing tools, stay tuned!',
    imageToImage: 'Image-to-Image',
    imageToImageDesc: 'Transform existing images with AI-powered editing and enhancement.',
    imageToImageDescription: 'Upload reference images and transform them with AI-powered editing. Perfect for style transfer, enhancement, and creative modifications.',
    textToImage: 'Text-to-Image',
    textToImageDesc: 'Generate stunning images from text descriptions using advanced AI.',
    textToImageDescription: 'Generate high-quality images from text descriptions using advanced AI technology. Simply describe what you want to see, and our AI will create stunning visuals for you.',
    textToImageMode: 'Text-to-Image Mode',
    size: 'Size',
    sizeDescriptions: {
      squareLarge: 'Square (1:1)',
      portrait23: 'Portrait (2:3)',
      landscape32: 'Landscape (3:2)',
      portrait34: 'Portrait (3:4)',
      landscape43: 'Landscape (4:3)',
      portrait45: 'Portrait (4:5)',
      landscape54: 'Landscape (5:4)',
      portrait916: 'Portrait (9:16)',
      landscape169: 'Landscape (16:9)',
      ultrawide219: 'Ultrawide (21:9)'
    }
  };
